export const FIELD_STATUS = { VALIDATED: "VALIDATED", UNREVIEWED: "UNREVIEWED" };
export const FIELD_TYPES = {
	TEXT: "TEXT",
	LIST: "LIST",
	CATEGORY: "CATEGORY",
	INTEGER: "INTEGER",
	DECIMAL: "DECIMAL",
	DATE: "DATE",
	DATE_TYPE: "DATE_TYPE",
};

export const LINE_HEIGHT = 20;

export const COMPLIANCE_STATUS = {
	COMPLIANT: "COMPLIANT",
	NON_COMPLIANT: "NON_COMPLIANT",
	PENDING: "PENDING",
	NOT_APPLICABLE: "NOT_APPLICABLE",
};
